var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-page"},[_c('div',{staticClass:"main-area"},[_c('section',{staticClass:"container mx-auto"},[_c('CheckoutStepper',{attrs:{"areas":_vm.areas}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }